import { Box, Typography } from '@mui/material';
import React from 'react'
import { fontLink, fullCenter } from '../../../base';
import { ReactComponent as LogoDark } from '../../Public/ShoppingCart/Coupon/CouponCart/logo_short_dark.svg';
import { Txt, useTxt } from '../../../Routes/Localized';
import VinButton from '../Header/VinButton';

export default function SearchDialog({ dialog, setDialog }) {

    if (!dialog) {
        return <></>;
    }

    return (
        <>
            <Box sx={{
                position: 'fixed', zIndex: "999999", width: '100vw', height: '100vh', top: 0, left: 0, bgcolor: 'rgba(0,0,0,0.3)',
                ...fullCenter, p: '16px'
            }} onClick={() => {
                if (dialog.forced) return;
                setDialog(false);
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '520px', borderRadius: '20px', bgcolor: 'white', minHeight: '180px', }}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', alignContent: 'center', justifyContent: 'center',
                        mb: '0px',
                        flex: '1 1 0',
                        mt: '0px',
                        width: '100%'
                    }}>

                        <Box sx={{
                            width: '100%', height: '48px', bgcolor: '#0165F4',
                            borderTopLeftRadius: '20px', borderTopRightRadius: '20px', ...fullCenter,
                            maxWidth: '100%',
                        }}>
                            <LogoDark style={{ width: '30px', height: '30px', display: 'block' }} />
                        </Box>
                        <Box flex="1 1 0" sx={{
                            display: 'flex', flexDirection: 'column',
                            textAlign: 'left',
                            alignItems: 'flex-start', alignContent: 'flex-start',
                            position: 'relative',
                            bgcolor: '#fff', py: '20px', width: '100%', maxWidth: '100%',
                            px: { xs: '16px', sm: '30px' },
                            borderBottomRightRadius: '20px', borderBottomLeftRadius: '20px'
                        }}>
                            <Typography sx={{
                                fontFamily: 'inter', fontWeight: 700, ...fontLink,
                                maxWidth: '400px'
                            }}>
                                <Txt id="64011" />
                            </Typography>
                            <Typography sx={{
                                fontFamily: 'inter', fontWeight: 400, ...fontLink,
                                maxWidth: '400px',
                            }}>
                                <Txt id="64018" />
                            </Typography>

                            <Box sx={{ display: 'flex', width: '100%', mt: '36px' }}>
                                <VinButton
                                    sx={{ border: '2px solid #4534C2' }}
                                    sxInput={{ py: '13px' }}
                                    headerView={true}
                                    sxButton={{ mb: '8px' }}
                                />
                            </Box>


                        </Box>

                    </Box>

                </Box>
            </Box>
        </>
    )
}
